import template from './checkout-summary.html';

export default template;
